import { render, staticRenderFns } from "./stockInOrderList.vue?vue&type=template&id=1f2dad0a&scoped=true&"
import script from "./stockInOrderList.vue?vue&type=script&lang=js&"
export * from "./stockInOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2dad0a",
  null
  
)

export default component.exports